import { useWindowSize } from 'react-use';

export default function useScreenDetection() {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 576;
  return { windowSize, isMobile };
}
